import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";

import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";

import * as questionIds from "../questions/questionIds";
import { HealthSurveillanceSectionProps } from "../models";
import { sections } from "../questionnaire";

// eslint-disable-next-line max-len
const HealthSurveillanceLAAWorkerSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.LAAWorker}
        >
            <TextQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.WhatPercentageOfTheTimeDoYouComeIntoContactWithAnimalOrChemicals)}
                readonly={props.readonly}
            />
            <TextQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.WhatTypeOfSubstancesDoYouComeIntoContactWith)}
                readonly={props.readonly}
                multiline
            />
            <TextQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DescribeYourMainTasks)}
                readonly={props.readonly}
                multiline
            />
            <TextQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HowLongHaveYouBeenInYourPresentPost)}
                readonly={props.readonly}
                multiline
            />
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HaveYourEverOrDoYouCurrentlySufferFromNailProblems),
                    getQuestionConfig(props.questionConfigs, questionIds.HaveYourEverOrDoYouCurrentlySufferFromNailProblemsDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(
                        props.questionConfigs,
                        questionIds.HaveYourEverOrDoYouCurrentlySufferFromInflammationOfYourMucousMembranesAndOrItchinessOfYourNose
                    ),
                    getQuestionConfig(
                        props.questionConfigs,
                        questionIds.HaveYourEverOrDoYouCurrentlySufferFromInflammationOfYourMucousMembranesAndOrItchinessOfYourNoseDetails
                    )
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverOrDoYouCurrentlySufferFromCoughingOrThroatIrritation),
                    getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverOrDoYouCurrentlySufferFromCoughingOrThroatIrritationDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DoYouSufferFromAllergiesOrHayFever),
                    getQuestionConfig(props.questionConfigs, questionIds.DoYouSufferFromAllergiesOrHayFeverWhenDoTheseSymptomsOccur)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DoYouSufferFromAPersistentRunnyNoseOtherThanACold),
                    getQuestionConfig(props.questionConfigs, questionIds.DoYouSufferFromAPersistentRunnyNoseOtherThanAColdWhenDoTheseSymptomsOccur)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DoYouSufferFromBoutsOfSneezingOtherThanACold),
                    getQuestionConfig(props.questionConfigs, questionIds.DoYouSufferFromBoutsOfSneezingOtherThanAColdWhenDoTheseSymptomsOccur)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DoYouSufferFromItchySoreOrWateryEyes),
                    getQuestionConfig(props.questionConfigs, questionIds.DoYouSufferFromItchySoreOrWateryEyesWhenDoTheseSymptomsOccur)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DoYouSufferFromCoughAndPhlegm),
                    getQuestionConfig(props.questionConfigs, questionIds.WhatColour)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceLAAWorkerSection = connect(makeMapStateToQuestionnaireSectionProps(sections.LAAWorker.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceLAAWorkerSectionUnconnected);
